import React, { useEffect } from "react";
import { FaFilePdf } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import {
  clearClientProfilePdf,
  exportClientProfilePdf,
} from "../../actions/getActions/getClientProfilePdfActions";
import {
  clientProfilePdfExportIsLoadingSelector,
  clientProfilePdfExportSelector,
} from "../../selectors";
import moment from "moment";

const ExportPdfButton = ({ clientNumber, categoryType, clientName }) => {
  const dispatch = useDispatch();

  const clientReportPdf = useSelector(clientProfilePdfExportSelector);
  const isLoading = useSelector(clientProfilePdfExportIsLoadingSelector);

  const handleExportPdf = () => {
    dispatch(
      exportClientProfilePdf({ clientNumber, categoryType, clientName })
    );
  };

  useEffect(() => {
    if (clientReportPdf.size > 0) {
      const url = URL.createObjectURL(clientReportPdf);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Client_Profile_${clientNumber}_${moment
        .utc()
        .local()
        .format("DD-MM-YYYY-HHmm")}.pdf`;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(url);
      }, 100);

      dispatch(clearClientProfilePdf());
    }
  }, [clientReportPdf]);

  return (
    <Button color="primary" onClick={handleExportPdf} disabled={isLoading}>
      <FaFilePdf size="1.3em" data-tip data-for="pdf-icon" color="white" />
      Download as PDF
    </Button>
  );
};

export default ExportPdfButton;



// WEBPACK FOOTER //
// ./src/features/client-profile/pages/client-profile-details-page/ExportPdfButton.jsx